import { faEnvelope, faPhone, faMagic } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import { AuthUser } from '../../../classes/AuthUser';
import { Routes } from '../../../classes/Routes';
import { ETranslation } from '../../../translations/translation-keys';
import Button, { EButtonSize } from '../../UI/Button/Button';
import InfoBox from '../../UI/InfoBox/InfoBox';
import ModalContext, { EModalSize } from '../../UI/Modal/ModalContext';
import ServiceGuideModal from '../../ServiceGuideModal/ServiceGuideModal';
import classes from './OfferRequestsInfo.module.scss';

interface IProps {
  authUser: AuthUser;
}

const OfferRequestsInfo: React.FC<IProps> = ({ authUser}) => {
  const history = useHistory();
  const { setModal } = useContext(ModalContext);
  
  const { t } = useTranslation();

  const openServiceGuideModal = () => setModal({
    isOpen: true,
    title: "Käyttöohjeet palveluun",
    size: EModalSize.MEDIUM,
    content: <ServiceGuideModal />,
  });

  return (
    <aside>
      <InfoBox className={classes.Box} style={{ padding: '1.5rem', border: '1px solid #e2e8f0', borderRadius: '8px', marginBottom: '1.5rem', boxShadow: 'none' }}>
        <h3 style={{ marginTop: 0, marginBottom: '1rem', fontSize: '1.1rem', color: '#0f172a', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span style={{ border: '1px solid #94a3b8', borderRadius: '50%', width: '18px', height: '18px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: '12px', color: '#64748b' }}>?</span> {t(ETranslation.OFFERREQUEST_INFO_OFFER_YOUR_SERVICE)}
        </h3>
        <ol style={{ color: '#475569', fontSize: '0.9rem', lineHeight: '1.5', margin: 0, paddingLeft: '1.2rem' }}>
          <li>{t(ETranslation.OFFERREQUEST_INFO_LIST_ITEM_1)}</li>
          <li>{t(ETranslation.OFFERREQUEST_INFO_LIST_ITEM_2)}</li>
          <li>{t(ETranslation.OFFERREQUEST_INFO_LIST_ITEM_3)}</li>
        </ol>
      </InfoBox>

      <InfoBox className={classes.Box} style={{ padding: '1.5rem', border: '1px solid #e2e8f0', borderRadius: '8px', marginBottom: '1.5rem', boxShadow: 'none' }}>
        <h3 style={{ marginTop: 0, marginBottom: '1rem', fontSize: '1.1rem', color: '#0f172a' }}>{t(ETranslation.OFFERREQUEST_INFO_QUESTIONS)}</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', color: '#475569', fontSize: '0.9rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><FontAwesomeIcon icon={faPhone} style={{ color: '#94a3b8' }} /> <a href="tel:+358443722362" style={{ color: 'inherit', textDecoration: 'none' }}>+358443722362</a></div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><FontAwesomeIcon icon={faEnvelope} style={{ color: '#94a3b8' }} /> <a href="mailto:pekka.nurmela@posp.fi" style={{ color: 'inherit', textDecoration: 'none' }}>pekka.nurmela@posp.fi</a></div>
        </div>
        <p style={{ color: '#475569', fontSize: '0.9rem', marginTop: '1rem', marginBottom: '1rem' }}>{t(ETranslation.OFFERREQUEST_INFO_READ_MORE)} <a target="_blank" rel="noreferrer" href="https://hankix.fi" style={{ color: '#3b82f6', textDecoration: 'none' }}>hankix.fi</a></p>
        <Button size={EButtonSize.SMALL} onClick={openServiceGuideModal} style={{ width: '100%', backgroundColor: '#f8fafc', color: '#334155', border: '1px solid #e2e8f0', padding: '8px', borderRadius: '4px' }}>Käyttöohjeet palveluun</Button>
      </InfoBox>

      <InfoBox className={classes.Box} style={{ padding: '1.5rem', border: '1px solid #e2e8f0', borderRadius: '8px', marginBottom: '1.5rem', boxShadow: 'none' }}>
        <h3 style={{ marginTop: 0, marginBottom: '1rem', fontSize: '1.1rem', color: '#0f172a' }}>{t(ETranslation.OFFERREQUEST_INFO_CONFIRM_INFO)}</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', color: '#475569', fontSize: '0.9rem', marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><span style={{ color: '#94a3b8' }}>🏢</span> {authUser?.organization.name}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><span style={{ color: '#94a3b8' }}>📍</span> {authUser?.organization.streetAddress || '-'}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><span style={{ color: '#94a3b8' }}>📍</span> {authUser?.organization.zip} {authUser?.organization.city || '-'}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}><FontAwesomeIcon icon={faPhone} style={{ color: '#94a3b8' }} /> {authUser?.organization.phone || '-'}</div>
        </div>
        <Button size={EButtonSize.SMALL} onClick={() => history.push(Routes.ORGANIZATIONS_ME)} style={{ width: '100%', backgroundColor: '#f8fafc', color: '#334155', border: '1px solid #e2e8f0', padding: '8px', borderRadius: '4px' }}>{t(ETranslation.OFFERREQUEST_INFO_EDIT_INFO)}</Button>
      </InfoBox>

      <InfoBox className={classes.Box} style={{ padding: '1.5rem', backgroundColor: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: '8px', display: 'flex', flexDirection: 'column', boxShadow: 'none' }}>
        <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '1.0rem', marginBottom: '12px', marginTop: 0, color: '#0f172a' }}>
          <FontAwesomeIcon icon={faMagic} style={{ color: '#3b82f6' }} />
          <span>Uusi: AI-vastausehdotus</span>
          <span style={{ backgroundColor: '#8b5cf6', color: 'white', padding: '2px 8px', borderRadius: '12px', fontSize: '0.65em', fontWeight: 'bold' }}>Beta</span>
        </h3>
        <p style={{ color: '#64748b', marginBottom: '15px', lineHeight: '1.5', fontSize: '0.9rem' }}>
          Laadi tarjouspyyntöön valmis vastausehdotus yrityksesi omien tietojen perusteella.
        </p>
        <div>
          <Button 
            size={EButtonSize.SMALL} 
            style={{ backgroundColor: 'white', color: '#334155', border: '1px solid #e2e8f0', borderRadius: '4px', width: 'auto', padding: '6px 12px' }} 
            onClick={() => history.push(Routes.ORGANIZATIONS_ME + '#ai-tarjous')}
          >
            Täydennä tiedot
          </Button>
        </div>
      </InfoBox>
    </aside>
  )
}

export default OfferRequestsInfo;
